// extracted by mini-css-extract-plugin
export default {"keyboard":"hpb5"};